import React, { useState } from 'react'
import { api } from '../../utils/api'
import { COLLECTION_METHODS, PICKABLE_METHODS, METHOD_LOCKED_TEXT, WAREHOUSE_LOCKED_TEXT } from './collectionMethods'

/**
 * Change a collection's method (Trac #1404).
 *
 * Open while no label, tracking or pickup exists and the collection is not on
 * hold. Prism is the real guard and answers 409 with the reason, which shows
 * inline. A save mutates the shipment in place and calls `onChanged(sendType)`,
 * the same pattern as CollectionHoldControl.
 */
export default function CollectionMethodPicker({ shipment, isBooked, isOnHold, onChanged }) {
  const current = shipment.send_type || 'courier'
  const [value, setValue] = useState(current)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  const isWarehouse = current === 'warehouse_dropoff'
  const locked = isBooked || isOnHold || isWarehouse
  const options = isWarehouse ? COLLECTION_METHODS.filter(m => m.value === current) : PICKABLE_METHODS
  const dirty = value !== current

  async function save() {
    setBusy(true)
    setError(null)
    try {
      await api.put(`/api/deals/collections/${shipment.id}/method`, { send_type: value })
      shipment.send_type = value
      onChanged?.(value)
    } catch (e) {
      setError(e.message || 'The method could not be changed.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        <select
          aria-label="Collection method"
          value={value}
          onChange={e => { setValue(e.target.value); setError(null) }}
          disabled={locked || busy}
          style={{ fontSize: 11, fontWeight: 600, padding: '4px 8px', borderRadius: 4, border: '1px solid var(--color-border)' }}
        >
          {options.map(m => (
            <option key={m.value} value={m.value}>{m.label}</option>
          ))}
        </select>
        {dirty && !locked && (
          <button
            className="btn btn-xs"
            onClick={() => { save() }}
            disabled={busy}
            style={{ fontSize: 10, padding: '3px 8px' }}
          >
            {busy ? 'Saving...' : 'Save method'}
          </button>
        )}
      </div>
      {(isWarehouse || isBooked) && (
        <div style={{ fontSize: 11, marginTop: 4, opacity: 0.9 }}>{isWarehouse ? WAREHOUSE_LOCKED_TEXT : METHOD_LOCKED_TEXT}</div>
      )}
      {error && (
        <div role="alert" style={{ fontSize: 11, marginTop: 4, padding: '4px 8px', borderRadius: 4, background: 'var(--color-bg)', color: 'var(--color-error)' }}>
          {error}
        </div>
      )}
    </div>
  )
}
